<template>
	<Timeline class="study-wrap">
		<TimelineItem v-for="(item, index) in alllist" :key="index">
			<span class="item-dot" slot="dot">
				<span></span>
			</span>
			<div class="study-title" @click="setVisible(item)" v-if="item.video_list.length > 0">
				<div v-if="!item.visible" class="title-icon">
					<i class="el-icon-circle-plus-outline" style="font-size: 16px;"></i>
				</div>
				<div v-else class="title-icon">
					<i class="el-icon-remove-outline" style="font-size: 16px;"></i>
				</div>

				<div class="title-text">
					{{ item.cate_name }}
				</div>
			</div>
			<div v-else class="study-title study-body">
				<div class="study-item" style="width: 100%; border:0;">
					<div class="title-text" style="font-size: 18px;  margin-right:30px;">
						{{ item.cate_name }}
					</div>
					<!-- <div class="progress">
            <div class="progress-title">学习进度</div>
            <div class="progress-bar">
              <Progress :percent="item.percent" hide-info :stroke-width="8"
                :stroke-color="['#27a4ff', '#227efa']" />
            </div>
            <div class="progress-text">
              {{ item.cont }}/{{ item.totality }}
            </div>
          </div> -->
					<div class="action">
						<router-link :to="{
                name: 'Study',
                params: { id: item.cid},
				 query: { cid: item.category_id, type_id: item.type_id }
              }"><Button type="primary" shape="circle" long>暂时没有视频</Button></router-link>
					</div>
				</div>
			</div>

			<transition-group name="slide-up" v-if="item.video_list.length > 0">
				<div v-show="item.visible" v-for="item1 in item.video_list" :key="item1.id">
					<div v-if="item1.length > 0">
						<div class="study-title" style="padding: 20px 0 13px 0; margin-left: 20px;">
							<div v-if="!item1.visible" class="title-icon">
								<i class="el-icon-circle-plus-outline" style="font-size: 16px;"></i>
							</div>
							<div v-else class="title-icon">
								<i class="el-icon-remove-outline" style="font-size: 16px;"></i>
							</div>
							<div class="title-text" style="font-size: 18px;">
								{{ item1.title }}
							</div>
						</div>

						<transition name="slide-up1">
							<div class="study-body" v-show="item1.visible">
								<div class="study-item" v-for="(chapter, chapterIndex) in item1" :key="chapterIndex"
									style="margin-left: 70px;" @click.stop="setnot()">
									<div class="name">{{ chapter.title }}</div>
									<!-- <div class="progress">
                    <div class="progress-title">学习进度</div>
                    <div class="progress-bar">
                      <Progress :percent="chapter.percent" hide-info :stroke-width="8"
                        :stroke-color="['#27a4ff', '#227efa']" />
                    </div>
                    <div class="progress-text">
                      {{ chapter.total_points }}/{{ chapter.totality }}
                    </div>
                  </div> -->
									<div class="action"  v-if="item1.is_study==0">
									<router-link :to="{
									    name: 'Study',
									    params: { cid: item.cid},
									   
									  }"><Button type="primary" shape="circle" long>开始学习</Button></router-link>
									</div>
									<div class="action"  v-else>
									<router-link :to="{
									    name: 'Study',
									    params: { cid: item.cid},
									   
									  }"><Button type="primary" shape="circle" long>继续学习</Button></router-link>
									</div>
								</div>
							</div>
						</transition>

					</div>
					<div v-else>
						<div class="study-body">
							<div class="study-item" style="margin-left: 40px;">
								<div class="name">{{ item1.title }}</div>

								<div class="action"  v-if="item1.is_study==0">
								<router-link :to="{
								    name: 'Study',
								    params: { cid: item.cid},
								   
								  }"><Button type="primary" shape="circle" long>开始学习</Button></router-link>
								</div>
								<div class="action"  v-else>
								<router-link :to="{
								    name: 'Study',
								    params: { cid: item.cid},
								   
								  }"><Button type="success" shape="circle" long>继续学习</Button></router-link>
								</div>
							</div>
						</div>
					</div>

				</div>
			</transition-group>
		</TimelineItem>
	</Timeline>
</template>
<script>
	import {
		getCourseList,
		getCourseDetail,
		getQuestionByCid,
		
		studyList,
		updateVideo,
		accessStatistical,
		updateRecord,
		getCourseRecordList
	} from "../../api/api";
	export default {
		props: {
			// ucid: {
			// 	type: Number,

			// },
			alllist:{
				type:Array,
				},
		},
		data() {
			return {
				ulista: [],
				specialList: [],
				
				playerOptions: {
					width: '800px',
					height: '500px',
					muted: false,
					language: 'en',
					playbackRates: [0.7, 1.0, 1.5, 2.0],
					sources: [{
						type: 'video/mp4',
						src: ''
					}],
				},
				videoPlayer: '',
			};
		},

		mounted() {
			 
		 this.$nextTick(function() {
			this.initCourseData();
				
			  });
			 

		},
		computed:{
			courseId:function(){
				return this.ucid
			},
			 
		},
		methods: {
			getData1() {
				 
				this.alllist.forEach((item, index) => {
					 
					if (index === 0) {
						this.$set(item, "visible", true);
					} else {
						this.$set(item, "visible", false);
					}
					if (item.length > 0) {
						item.forEach((item1, index1) => {
							if (index1 === 0) {
								this.$set(item1, "visible", true);
							} else {
								this.$set(item1, "visible", false);
							}
							if (item1.video_list.length > 0) {
								item1.video_list.forEach((chapter, chapterIndex) => {
									let percent = 0;
									if (chapter.cont > chapter.totality) {
										percent = 100;
									} else if (chapter.totality > 0) {
										percent = parseInt(
											(chapter.cont / chapter.totality) * 100
										);
									}
									this.$set(chapter, "percent", percent);
								});
							} else {
								let percent = 0;
								if (item1.cont > item1.totality) {
									percent = 100;
								} else if (item1.totality > 0) {
									percent = parseInt(
										(item1.cont / item1.totality) * 100
									);
								}
								this.$set(item1, "percent", percent);
							}
						})
					}
				});
			},
			setVisible(item) {
				item.visible = !item.visible;
			},
			setnot() {
				return false;
			},
			initCourseData() {
				// this.courseId = this.ucid;
				this.getData1();
				 // this.getCourseSpecialType();
				
			 
					 
			},
			
		},
	};
</script>
<style lang="less" scoped>
	.study-wrap {
		padding: 0 10px;

		.item-dot {
			width: 15px;
			height: 15px;
			border-radius: 15px;
			border: 1px solid #ddd;
			display: inline-flex;
			align-items: center;
			justify-content: center;

			span {
				width: 7px;
				height: 7px;
				border-radius: 7px;
				background: #eee;
			}
		}

		/deep/.ivu-timeline-item-tail {
			border: 1px dashed #ddd;
		}
	}

	.study-title {
		margin-top: -6px;
		border-bottom: 1px solid #eee;
		display: flex;
		align-items: center;
		padding-bottom: 16px;
		cursor: pointer;

		.title-icon {
			margin-right: 16px;
		}

		.title-text {
			font-size: 20px;
		}
	}

	.study-body {
		.study-item {
			display: flex;
			align-items: center;
			border-bottom: 1px dashed #ddd;
			margin-left: 40px;
			padding: 16px 0;
justify-content: space-between;
			.name {
				width: 530px;
				font-size: 16px;
				color: #666;
				margin-right: 30px;
				// .ellipsis();
			}

			.progress {
				flex: 1;
				display: flex;
				align-items: center;

				&-title {
					font-size: 16px;
					color: #666;
					margin-right: 10px;
				}

				&-bar {
					width: 200px;
					margin-right: 10px;
				}

				&-text {
					flex: 1;
					font-size: 16px;
					color: #666;
				}
			}

			.action {
				width: 100px;
			}
		}
	}
</style>
